var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.notification_counter > 0)?_c('v-btn',{attrs:{"elevation":"2","fab":""},on:{"click":_vm.goToNotifications}},[_c('v-icon',[_vm._v(" mdi-bell ")]),_c('span',[_vm._v(_vm._s(_vm.notification_counter))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }